import api from './index'

export type AttentionKey =
  | 'referee_no_show'
  | 'referee_manual_review'
  | 'referee_escrow'
  | 'payouts_pending'
  | 'closed_clubs'
  | 'leak_control'
  | 'negative_balances'
  | 'new_stadiums'
  | 'championship_moderation'
  | 'equipment_reports'
  | 'kit_orders'
  | 'referee_applications'
  | 'coach_applications'
  | 'support'
  | 'complaints'
  | 'tailscale_api_credential'
  | 'device_key_expiry'

export type AttentionSeverity = 'critical' | 'normal'

export interface AttentionItem {
  key: AttentionKey
  group: string
  title: string
  count: number
  new_count: number
  oldest_at: string | null
  overdue_count: number
  severity: AttentionSeverity
  route: string
}

export interface AttentionResponse {
  items: AttentionItem[]
  total: number
  total_new: number
  total_overdue: number
  generated_at: string
}

const attentionApi = {
  async get(): Promise<AttentionResponse> {
    const response = await api.get<AttentionResponse>('/admin/attention')
    return response.data
  },
  async markSeen(key: AttentionKey): Promise<void> {
    await api.post(`/admin/attention/${encodeURIComponent(key)}/seen`)
  }
}

export default attentionApi
